"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumb = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const elements_1 = require("../../elements");
const FileSystem_1 = require("../FileSystem");
const BreadCrumb = ({ onClick, items, folders }) => {
    const handleClick = (item) => (event) => {
        if (onClick) {
            onClick(item, event);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "bread-crumb" }, { children: items.map((item, index) => {
            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [folders && ((0, jsx_runtime_1.jsx)(FileSystem_1.Folder, Object.assign({ item: { name: '', path: item.path, children: [] }, className: "bread-crumb__crumb", onClick: handleClick(item), disableDrag: true, disableContextMenu: true }, { children: item.label }), void 0)), !folders && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "bread-crumb__crumb", onClick: handleClick(item) }, { children: item.label }), void 0)), index < items.length - 1 && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "bread-crumb__separator" }, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "caretRight" }, void 0) }), void 0))] }, index));
        }) }), void 0));
};
exports.BreadCrumb = BreadCrumb;
//# sourceMappingURL=BreadCrumb.js.map